import { UTCMillisecondsSchema } from '../time'
import { ParticipantIdSchema } from './shared'
import { z } from 'zod'

export const BracketMatchSchema = z.object({
  id: z.number().min(1),
  participant1: ParticipantIdSchema.optional(),
  participant2: ParticipantIdSchema.optional(),
  winner: z.literal(1).or(z.literal(2)).optional().describe('1 if winner is player 1, 2 if player 2'),
  overrideReason: z.string().optional(),
  winnerGame: z.number().optional().describe('bracket id for the winners next game'),
  loserGame: z.number().optional().describe('bracket id for the losers next game'),
  order: z.number().optional().describe('order of the match in the round'),
})
export type BracketMatch = z.infer<typeof BracketMatchSchema>

export const BracketRoundSchema = z.object({
  round: z.number().gte(0).describe('The round number'),
  startDate: UTCMillisecondsSchema.describe('The start date of the round'),
  endDate: UTCMillisecondsSchema.describe('The end date of the round'),
  matches: z.array(BracketMatchSchema).describe('The games in the round'),
})
export type BracketRound = z.infer<typeof BracketRoundSchema>
